"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExposeNameCase = exports.ExposeNameCaseEnum = void 0;
const case_anything_1 = require("case-anything");
const class_transformer_1 = require("class-transformer");
var ExposeNameCaseEnum;
(function (ExposeNameCaseEnum) {
    ExposeNameCaseEnum[ExposeNameCaseEnum["LOWER_CASE"] = 0] = "LOWER_CASE";
    ExposeNameCaseEnum[ExposeNameCaseEnum["UPPER_CASE"] = 1] = "UPPER_CASE";
    ExposeNameCaseEnum[ExposeNameCaseEnum["KEBAB_CASE"] = 2] = "KEBAB_CASE";
    ExposeNameCaseEnum[ExposeNameCaseEnum["SNAKE_CASE"] = 3] = "SNAKE_CASE";
    ExposeNameCaseEnum[ExposeNameCaseEnum["CAMEL_CASE"] = 4] = "CAMEL_CASE";
    ExposeNameCaseEnum[ExposeNameCaseEnum["PASCAL_CASE"] = 5] = "PASCAL_CASE";
})(ExposeNameCaseEnum = exports.ExposeNameCaseEnum || (exports.ExposeNameCaseEnum = {}));
function transformCase(value, nameCase) {
    switch (nameCase) {
        case ExposeNameCaseEnum.LOWER_CASE:
            return value.toLowerCase();
        case ExposeNameCaseEnum.UPPER_CASE:
            return value.toUpperCase();
        case ExposeNameCaseEnum.KEBAB_CASE:
            return (0, case_anything_1.kebabCase)(value);
        case ExposeNameCaseEnum.SNAKE_CASE:
            return (0, case_anything_1.snakeCase)(value);
        case ExposeNameCaseEnum.CAMEL_CASE:
            return (0, case_anything_1.camelCase)(value);
        case ExposeNameCaseEnum.PASCAL_CASE:
            return (0, case_anything_1.pascalCase)(value);
    }
}
/**
 * Exposes property name in specified case type.
 *
 * @example
 * class Example {
 *   @ExposeNameCase(ExposeNameCaseEnum.snakeCase)
 *   @IsString()
 *   public propertyName: string;
 * }
 *
 * console.log(JSON.stringify(example)); // output: { "property_name": "value" }
 */
const ExposeNameCase = (nameCase) => (target, key) => (0, class_transformer_1.Expose)({
    name: transformCase(key.toString(), nameCase),
})(target, key);
exports.ExposeNameCase = ExposeNameCase;
